export var ERewardSourceType;
(function (ERewardSourceType) {
    ERewardSourceType["GIFTCARD"] = "giftcard";
    ERewardSourceType["CASHBACK"] = "cashbackOffer";
})(ERewardSourceType || (ERewardSourceType = {}));
